import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";

import ModalConfirm from "../../components/Modals/ModalConfirm.vue"
import PropertyMap from "../../components/Customer/PropertyMap.vue"
import TalhaoMap from "../../components/Customer/TalhaoMap.vue"

import { INITIAL_STATE_CUSTOMER, INVALID_FIELDS_CUSTOMER } from "../../initialStates/customer";
import { INITIAL_STATE_CUSTOMER_PROPERTIES, INVALID_FIELDS_CUSTOMER_PROPERTIES } from "../../initialStates/customerProperties";
import { INITIAL_STATE_TALHAO, INVALID_FIELDS_TALHAO } from "../../initialStates/talhao";

import ServiceCustomer from "../../services/serviceCustomer"
import ServiceCustomerProperty from "../../services/serviceCustomerProperty";
import ServiceTalhao from "../../services/serviceTalhao";
import ServiceAux from "../../services/serviceAux"

import { ValidateCustomer } from "../../validators/customer"
import { ValidateCustomerProperties } from "../../validators/customerProperties";
import { ValidateTalhao } from "../../validators/talhao";
import toastAlertErros from "../../utils/toastAlertErros";
import { handleCpfOrCnpj } from "../../utils/validateCpfCnpj";
import { HandleErrors } from "../../utils/handleErrors";
import { removeReference } from "../../utils/removeReference";
import { ufs } from "../../common";

import whatsapp from "../../assets/whatsapp.svg";

const phoneMask = (value) => {
  const mask = value.replace(/\D/g, "").length > 10
    ? "(##) #####-####"
    : "(##) ####-####";

  return mask.split("").map((character) => character === "#" ? /\d/ : character);
};

const mixinCustomer = {
  props: {
    readOrEditCustomers: {
      type: Object,
    },
    clearAll: {
      type: Boolean,
    },
    idCustomerFromSearch: {
      type: String,
      default: ""
    }
  },
  components: {
    ModalConfirm,
    PropertyMap,
    TalhaoMap,
  },
  data() {
    return {
      whatsapp: whatsapp,
      dataCostumer: removeReference(INITIAL_STATE_CUSTOMER),
      invalidFields: removeReference(INVALID_FIELDS_CUSTOMER),
      property: removeReference(INITIAL_STATE_CUSTOMER_PROPERTIES),
      invalidFieldsProperty: removeReference(INVALID_FIELDS_CUSTOMER_PROPERTIES),
      talhao: removeReference(INITIAL_STATE_TALHAO),
      invalidFieldsTalhao: removeReference(INVALID_FIELDS_TALHAO),
      spinGeneralCnpj: false,
      consumidorFinal: [
        { value: "0", text: "0 - Normal" },
        { value: "1", text: "1 - Consumidor final" },
      ],
      status: [
        { value: "ativo", text: "Ativo" },
        { value: "inativo", text: "Inativo" },
      ],
      contribuinte: [
        { value: "1", text: "1 - Contribuinte ICMS" },
        {
          value: "2",
          text: "2 - Contribuinte isento de Inscrição no cadastro de Contribuintes do ICMS",
        },
        {
          value: "9",
          text: "9 - Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS.",
        },
      ],
      getCustomer: false,
      spinGeneral: false,
      ufs: ufs,
      tabs: [
        { value: "Informações Gerais", text: "Informações Gerais" },
        { value: "Propriedades", text: "Propriedades" },
      ],
      tobs: [
        { value: "Propriedade", text: "Propriedade" },
        { value: "Talhão", text: "Talhão" },
      ],
      selectedLabel: "Informações Gerais",
      selectedMap: "Propriedade",
      customerProperties: [],
      propertyIdToDelete: null,
      talhoes: [],
      talhaoIdToDelete: null,
      isLoading: false,
      propertyMarkerCoords: null,
    };
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
    ]),
    storeLabelName(labelName) {
      this.selectedLabel = labelName;
    },
    storeMapName(labelName) {
      this.selectedMap = labelName;
    },
    applyMapLocation(location) {
      Object.assign(this.property, location)
      this.propertyMarkerCoords = { lat: Number(location.latitude), lng: Number(location.longitude) }
      const requiredAddressFields = ["cep", "cidade", "uf"]
      requiredAddressFields.forEach((field) =>
        this.clearInvalidFields(field, "invalidFieldsProperty")
      )
    },
    applyGeocodedLocation(location) {
      Object.assign(this.property, location)
      this.propertyMarkerCoords = { lat: Number(location.latitude), lng: Number(location.longitude) }
      const requiredAddressFields = ["cep", "cidade", "uf"]
      requiredAddressFields.forEach((field) =>
        this.clearInvalidFields(field, "invalidFieldsProperty")
      )
    },
    applyTalhaoLocation(location) {
      this.talhao.latitude = location.latitude
      this.talhao.longitudade = location.longitude
    },
    selectPropertyRow(property) {
      this.findProperty(property.id)
    },
    clearCustomerInputs() {
      this.dataCostumer = removeReference(INITIAL_STATE_CUSTOMER)

      this.SET_DATA_SEARCH_FROM_CUSTOMER({})
    },

    clearCustomerPropertyInputs() {
      this.property = removeReference(INITIAL_STATE_CUSTOMER_PROPERTIES)
      this.propertyMarkerCoords = null
      this.clearTalhaoInputs()
      this.talhoes = []
    },

    clearTalhaoInputs() {
      this.talhao = {
        ...removeReference(INITIAL_STATE_TALHAO),
        idPropriedade: this.property.id || null,
      }
      this.invalidFieldsTalhao = removeReference(INVALID_FIELDS_TALHAO)
    },

    saveOrUpdateCustomer() {
      if (!this.handleValidate()) return

      if (!this.dataCostumer.id) {
        this.saveCustomer();
      } else {
        this.updateCustomer();
      }
    },

    async saveCustomer() {
      try {
        this.isLoading = true;
        const result = handleCpfOrCnpj(this.dataCostumer.cpfCnpj, this.$toast)
        if (result && !result.isValid) {
          return result.alert()
        }

        const { data } = await api.post("/customers", this.dataCostumer);
        this.dataCostumer.id = data.id;
        this.property.idCliente = data.id

        this.$emit("getAllCustomer", this.getCustomer);
        this.getCustomer = !this.getCustomer;
        this.SET_IS_SEARCH_REGISTERS();

        this.verifyExistsProperties()

        return this.$toast.open({
          message: "Cliente salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes('NOT_ALLOWED'))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }
        else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      } finally {
        this.isLoading = false;
      }
    },

    async updateCustomer() {
      try {
        this.isLoading = true;
        const result = handleCpfOrCnpj(this.dataCostumer.cpfCnpj, this.$toast)
        if (result && !result.isValid) {
          return result.alert()
        }

        await api.put("/customers/" + this.dataCostumer.id, this.dataCostumer);

        this.$emit("getAllCustomer", this.getCustomer);
        this.getCustomer = !this.getCustomer;
        this.SET_IS_SEARCH_REGISTERS();

        this.verifyExistsProperties()

        this.$toast.open({
          message: "Cliente atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes('NOT_ALLOWED'))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }
        else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      } finally {
        this.isLoading = false;
      }
    },

    async saveOrUpdateProperty() {
      if (!this.handleValidate('customerProperty')) return

      if (!this.property.id)
        await this.saveProperty();
      else
        await this.updateProperty();

      await this.listProperties()
    },

    handleValidate(typeItem = "customer") {
      const types = {
        customer: () => ValidateCustomer(this.dataCostumer),
        customerProperty: () => ValidateCustomerProperties(this.property),
        talhao: () => ValidateTalhao(this.talhao),
      };

      const invalidFields = {
        customer: "invalidFields",
        customerProperty: "invalidFieldsProperty",
        talhao: "invalidFieldsTalhao",
      };

      return this.handleErrors(types[typeItem](), invalidFields[typeItem]);
    },

    handleErrors(errors, typeValidate = "invalidFields") {
      if (errors && errors.length) {
        errors.forEach((erro) => {
          this[typeValidate][erro.keyError] = "isInvalidInput";
        });

        this.$toast.open({
          message: "Existem campos obrigatórios!",
          type: "info",
        });

        return false;
      }

      return true;
    },

    clearInvalidFields(key, type = "invalidFields") {
      if (this[type][key]) this[type][key] = "";
    },

    async saveProperty() {
      try {
        await ServiceCustomerProperty.save({ ...this.property, idCliente: this.dataCostumer.id })

        this.clearCustomerPropertyInputs()

        this.$toast.open({
          type: 'success',
          message: 'Nova propriedade registrada'
        })
      } catch (error) {
        const message = error?.response?.data?.message

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes('NOT_ALLOWED'))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          return this.$toast.open({
            message: message,
            type: "info",
          });
      }
    },

    async updateProperty() {
      try {
        await ServiceCustomerProperty.update({ ...this.property, idCliente: this.dataCostumer.id })

        this.clearCustomerPropertyInputs()

        this.$toast.open({
          type: 'success',
          message: 'Propriedade Atualizada'
        })
      } catch (error) {
        const message = error?.response?.data?.message

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes('NOT_ALLOWED'))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      }
    },

    async listProperties() {
      try {
        this.customerProperties = await ServiceCustomerProperty.fillComobobox(this.dataCostumer.id)
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || 'Ocorreu um problema ao listar as propriedades',
          type: 'info'
        })
      }
    },

    async findProperty(id) {
      try {
        this.property = await ServiceCustomerProperty.findById(id)
        this.propertyMarkerCoords = null
        this.clearTalhaoInputs()
        await this.listTalhoes()
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || 'Ocorreu um problema ao buscar a propriedade',
          type: 'info'
        })
      }
    },

    async saveOrUpdateTalhao() {
      if (!this.property.id || !this.handleValidate("talhao")) return

      if (this.talhao.id) await this.updateTalhao()
      else await this.saveTalhao()

      await this.listTalhoes()
    },

    async saveTalhao() {
      try {
        await ServiceTalhao.save({ ...this.talhao, idPropriedade: this.property.id })
        this.clearTalhaoInputs()
        this.$toast.open({ type: "success", message: "Novo talhão registrado" })
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: error?.response?.data?.erros || error?.response?.data?.message || "Ocorreu um problema ao salvar o talhão",
        })
      }
    },

    async updateTalhao() {
      try {
        await ServiceTalhao.update({ ...this.talhao, idPropriedade: this.property.id })
        this.clearTalhaoInputs()
        this.$toast.open({ type: "success", message: "Talhão atualizado" })
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: error?.response?.data?.erros || error?.response?.data?.message || "Ocorreu um problema ao atualizar o talhão",
        })
      }
    },

    async listTalhoes() {
      if (!this.property.id) {
        this.talhoes = []
        return
      }

      try {
        this.talhoes = await ServiceTalhao.findByPropertyId(this.property.id)
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: error?.response?.data?.message || "Ocorreu um problema ao listar os talhões",
        })
      }
    },

    async findTalhao(id) {
      try {
        this.talhao = await ServiceTalhao.findById(id)
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: error?.response?.data?.message || "Ocorreu um problema ao buscar o talhão",
        })
      }
    },

    getTalhaoIdToDelete(id) {
      this.talhaoIdToDelete = id
      this.$bvModal.show("confirmDeleteTalhao")
    },

    async deleteTalhao() {
      try {
        await ServiceTalhao.delete(this.talhaoIdToDelete)
        this.$bvModal.hide("confirmDeleteTalhao")
        this.clearTalhaoInputs()
        await this.listTalhoes()
        this.$toast.open({ type: "success", message: "Talhão removido com sucesso!" })
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: error?.response?.data?.message || "Ocorreu um problema ao excluir o talhão",
        })
      } finally {
        this.talhaoIdToDelete = null
      }
    },

    getPropertyIdToDelete(id) {
      this.$bvModal.show('confirmDeleteProperty')

      this.propertyIdToDelete = id
    },

    async deleteProperty() {
      try {
        await ServiceCustomerProperty.delete(this.propertyIdToDelete)

        this.$toast.open({
          message: 'Propriedade removida com sucesso!'
        })

        this.$bvModal.hide('confirmDeleteProperty')
        if (this.property.id === this.propertyIdToDelete)
          this.clearCustomerPropertyInputs()
        await this.listProperties()
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || 'Ocorreu um problema ao deletar a propriedade',
          type: 'info'
        })
      } finally {
        this.propertyIdToDelete = null
      }
    },

    async fetchCnpj(cnpj, item = 'dataCostumer') {
      try {
        this.spinGeneralCnpj = true;
        const formatedCnpj = cnpj.replace(/\D/g, "");
        const { data } = await api.get(`/aux/cnpj/${formatedCnpj}`);
        if (data.nome_fantasia) {
          this[item].nome = data.nome_fantasia;
        } else {
          this[item].nome = data.razao_social;
        }
        this[item].endereco = data.logradouro;
        this[item].numero = data.numero;
        this[item].bairro = data.bairro;
        this[item].cidade = data.municipio;
        this[item].uf = data.uf;
        this[item].telefone = data.ddd_telefone_1;
        this[item].cep = data.cep;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CNPJ e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneralCnpj = false;
      }
    },

    async findById(idCustomer) {
      const customer = await ServiceCustomer.findById(idCustomer)
      return customer
    },


    async handleModalCreateCustomer() {
      const customer = await this.findById(this.idCustomerFromSearch)
      this.SET_DATA_SEARCH_FROM_CUSTOMER(customer)
      this.assingEditCustomer()
    },

    verifyExistsProperties() {
      if (!this.customerProperties.length) {
        this.$bvModal.show('verifyProperty');
      }
    },

    assingCustomerAddressToProperties() {
      this.storeLabelName('Propriedades')

      this.property.nome = `PROPRIEDADE ${this.dataCostumer.nome}`
      this.property.cpfCnpj = this.dataCostumer.cpfCnpj
      this.property.cep = this.dataCostumer.cep
      this.property.endereco = this.dataCostumer.endereco
      this.property.bairro = this.dataCostumer.bairro
      this.property.cidade = this.dataCostumer.cidade
      this.property.uf = this.dataCostumer.uf
      this.property.ibge = this.dataCostumer.ibge
      this.property.numero = this.dataCostumer.numero
      this.property.complemento = this.dataCostumer.complemento
      this.property.latitude = this.dataCostumer.latitude
      this.property.longitude = this.dataCostumer.longitude
    },

    assingEditCustomer() {
      this.dataCostumer.id = this.dataSearchCustomer.id;
      this.dataCostumer.nome = this.dataSearchCustomer.nome;
      this.dataCostumer.cpfCnpj = this.dataSearchCustomer.cpfCnpj;
      this.dataCostumer.rg = this.dataSearchCustomer.rg;
      this.dataCostumer.ie = this.dataSearchCustomer.ie;
      this.dataCostumer.endereco = this.dataSearchCustomer.endereco;
      this.dataCostumer.numero = this.dataSearchCustomer.numero;
      this.dataCostumer.complemento = this.dataSearchCustomer.complemento;
      this.dataCostumer.bairro = this.dataSearchCustomer.bairro;
      this.dataCostumer.cidade = this.dataSearchCustomer.cidade;
      this.dataCostumer.uf = this.dataSearchCustomer.uf;
      this.dataCostumer.ibge = this.dataSearchCustomer.ibge;
      this.dataCostumer.cep = this.dataSearchCustomer.cep;
      this.dataCostumer.telefone = this.dataSearchCustomer.telefone;
      this.dataCostumer.celular = this.dataSearchCustomer.celular;
      this.dataCostumer.email = this.dataSearchCustomer.email;
      this.dataCostumer.dataNascimento = this.dataSearchCustomer.dataNascimento;
      this.dataCostumer.consumidor_final = this.dataSearchCustomer.consumidor_final;
      this.dataCostumer.contribuinte = this.dataSearchCustomer.contribuinte;
      this.dataCostumer.observacao = this.dataSearchCustomer.observacao;
      this.dataCostumer.status = this.dataSearchCustomer.status;
      this.dataCostumer.latitude = this.dataSearchCustomer.latitude;
      this.dataCostumer.longitude = this.dataSearchCustomer.longitude;

      this.property.idCliente = this.dataCostumer.id

      this.customerProperties = this.dataSearchCustomer.propriedades
    },

    async fetchCep(cep, key = "dataCostumer") {
      try {
        this.spinGeneral = true;
        const formatedCep = cep.replace(/\D/g, "");
        const data  = await ServiceAux.getCep(formatedCep);

        this[key].endereco = data.street;
        this[key].bairro = data.neighborhood
        this[key].cidade = data.city
        this[key].uf = data.state
        this[key].cep = data.cep
        this[key].ibge = data.ibge

        if (key === 'property') {
          const enderecoCompleto = `${data.street}, ${data.city}, ${data.state}, Brasil`
          this.$nextTick(() => {
            if (this.$refs.propertyMap) {
              this.$refs.propertyMap.geocodeAddress(enderecoCompleto)
            }
          })
        }

      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar as informações , verifique o CEP e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    handleNewCustomer() {
      this.clearCustomerInputs()
      this.clearCustomerPropertyInputs()

      this.customerProperties = []
      this.propertyIdToDelete = null
      this.talhoes = []
      this.talhaoIdToDelete = null
    },
    checkInputLength(isCustomerProperty = false) {
      if (isCustomerProperty) {
        if (this.property?.cpfCnpj?.length === 18)
          this.$forceUpdate();
      } else if (this.dataCostumer.cpfCnpj.length === 18)
        this.$forceUpdate();

      this.clearInvalidFields('cpfCnpj')
    },
    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },
    maskCpfCnpj(cpfCnpj) {
      if (cpfCnpj === null) {
        return "";
      }
      if (cpfCnpj.length <= 14) {
        return "###.###.###-##";
      }
      if (cpfCnpj.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    }
  },
  watch: {
    readOrEditCustomers() {
      Object.assign(this.dataCostumer, this.readOrEditCustomers);
    },
    clearAll() {
      this.clearCustomerInputs();
      this.clearCustomerPropertyInputs()
    },
  },

  mounted() {
    if (this.dataSearchCustomer.id) {
      this.assingEditCustomer();
    } else if (this.idCustomerFromSearch) {
      this.handleModalCreateCustomer()
    }
  },
  computed: {
    ...mapState({
      dataSearchCustomer: (state) => state.dataSearchCustomer,
    }),
    maskCelular() {
      return "(##) #####-####";
    },
    maskTelefone() {
      return phoneMask;
    },
    maskCep() {
      return "#####-###";
    },
    isInputLengthValid() {
      if (this.dataCostumer.cpfCnpj)
        return this.dataCostumer.cpfCnpj.length === 18;
    },
    isInputPropertyLengthValid() {
      if (this.property.cpfCnpj)
        return this.property.cpfCnpj.length === 18;
    },
  },
  beforeDestroy() {
    this.clearCustomerInputs();
    this.clearCustomerPropertyInputs()
    this.clearTalhaoInputs()
  }
}

export default mixinCustomer
